






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { formatPhoneNum } from '@/modules/_common/utils/formatPhoneNum';
@Component({
  name: 'TableWithTitle',
})
export default class TableWithTitle extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly headers: any[];
  @Prop() readonly items: any[];
  @Prop() readonly hideFooter: boolean;
  @Prop({ default: true }) readonly disableLink: boolean;
  @Prop() readonly loading: boolean;
  @Prop() readonly route: boolean;
  @Prop() readonly params: object;
  formatPhoneNum(value) {
    return formatPhoneNum(value);
  }
  onRowClicked(value) {
    if (!this.disableLink) {
      this.$router.push({
        path: `${this.route}/${value.deliverySpaces.companyDistrictNo}`,
        query: { deliverySpaceNo: value.deliverySpaceNo },
      });
    }
  }
}
